import { AddUsersToPlanUseCase } from "@/application/usecases/AddUsersToPlanUseCase";
import { CreatePartnerUseCase } from "@/application/usecases/CreatePartnerUseCase";
import { ListCancellationReasonsUseCase } from "@/application/usecases/ListCancellationReasonsUseCase";
import { ListPartnersUseCase } from "@/application/usecases/ListPartnersUseCase";
import { ListUserSubscriptionHistoryUseCase } from "@/application/usecases/ListUserSubscriptionHistoryUseCase";
import { ShowPartnerUseCase } from "@/application/usecases/ShowPartnerUseCase";
import repositories from "./repositories";
import { ListPrescriptionFeedbackUseCase } from "@/application/usecases/ListPrescriptionFeedbackUseCase";
import { CreateQuestionaireUseCase } from "@/application/usecases/CreateQuestionaireUseCase";
import { ListQuestionairesUseCase } from "@/application/usecases/ListQuestionairesUseCase";
import { ShowQuestionaireUseCase } from "@/application/usecases/ShowQuestionaireUseCase";
import { UpdateQuestionaireStatusUseCase } from "@/application/usecases/UpdateQuestionaireStatusUseCase";


export default {
    createPartnerUseCase: new CreatePartnerUseCase(repositories.partnerRepository),
    listPartnersUseCase: new ListPartnersUseCase(repositories.partnerRepository),
    showPartnerUseCase: new ShowPartnerUseCase(repositories.partnerRepository),
    addUsersToPlanUseCase: new AddUsersToPlanUseCase(repositories.partnerRepository),
    listUserSubscriptionHistoryUseCase: new ListUserSubscriptionHistoryUseCase(repositories.userSubscriptionHistoryRepository),
    listPrescriptionFeedbacks: new ListPrescriptionFeedbackUseCase(repositories.userSubscriptionHistoryRepository),
    listCancellationReasons: new ListCancellationReasonsUseCase(repositories.userSubscriptionHistoryRepository),
    createQuestionaireUseCase: new CreateQuestionaireUseCase(repositories.questionaireRepository),
    listQuestionairesUseCase: new ListQuestionairesUseCase(repositories.questionaireRepository),
    showQuestionaireUseCase: new ShowQuestionaireUseCase(repositories.questionaireRepository),
    updateQuestionaireStatusUseCase: new UpdateQuestionaireStatusUseCase(repositories.questionaireRepository),
}